import './scss/main.scss'

import { createApp } from 'vue'
import App from './App.vue'
import { createVuestic } from 'vuestic-ui'
import axios from 'axios'

import { createGtm } from '@gtm-support/vue-gtm'
import stores from './stores'
import router from './router'
import VCalendar from 'v-calendar'
import 'v-calendar/style.css'

const token = localStorage.getItem('token')
if (token) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
}

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token')
      delete axios.defaults.headers.common['Authorization']
      router.push({ name: 'login' })
    }
    return Promise.reject(error)
  },
)
import vuesticGlobalConfig from './services/vuestic-ui/global-config'

const app = createApp(App)

app.use(stores)
app.use(router)
app.use(createVuestic({ config: vuesticGlobalConfig }))
app.use(VCalendar, {})

if (import.meta.env.VITE_APP_GTM_ENABLED) {
  app.use(
    createGtm({
      id: import.meta.env.VITE_APP_GTM_KEY,
      debug: false,
      vueRouter: router,
    }),
  )
}

app.mount('#app')
